import React, { useEffect } from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import { findApp, SUPPORT_EMAIL } from '../data/apps';
import { AppIcon } from './Apps';
import './Apps.css';

const AppDetail = () => {
  const { slug } = useParams();
  const app = findApp(slug);

  useEffect(() => {
    if (app) document.title = `${app.name} — SVT Consulting`;
    window.scrollTo(0, 0);
  }, [app]);

  if (!app) return <Navigate to="/apps" replace />;
  if (!app.privacy && app.site) {
    window.location.replace(app.site);
    return null;
  }

  return (
    <div className="apps-page">
      <section className="app-hero" style={{ '--accent': app.accent || '#2c3e50' }}>
        <div className="container app-hero-inner">
          <AppIcon app={app} size={112} />
          <div>
            <p className="apps-eyebrow"><Link to="/apps">Apps</Link> / {app.name}</p>
            <h1>{app.name}</h1>
            <p className="apps-lede">{app.tagline}</p>
            <p className="app-platforms">{app.platforms.join(' · ')}</p>
            <div className="app-cta">
              {app.storeUrl ? (
                <a className="btn-store" href={app.storeUrl} target="_blank" rel="noopener noreferrer">Download on the App Store</a>
              ) : (
                <span className="app-status app-status-coming-soon big">Coming soon to the App Store</span>
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="app-body">
        <div className="container narrow">
          <p className="app-description">{app.description}</p>

          {app.features && (
            <div className="app-features">
              {app.features.map((f) => (
                <div className="app-feature" key={f.title}>
                  <h3>{f.title}</h3>
                  <p>{f.text}</p>
                </div>
              ))}
            </div>
          )}

          {app.notAffiliated && <p className="app-note">{app.notAffiliated}</p>}

          <div className="app-links-row">
            <Link to={`/apps/${app.slug}/privacy`} className="app-link-card">
              <strong>Privacy policy</strong>
              <span>What stays on your device, and the few things that leave it.</span>
            </Link>
            <Link to={`/apps/${app.slug}/support`} className="app-link-card">
              <strong>Support</strong>
              <span>Common questions, and {SUPPORT_EMAIL} for the rest.</span>
            </Link>
            <Link to={`/apps/${app.slug}/terms`} className="app-link-card">
              <strong>Terms of use</strong>
              <span>The short, plain-language version.</span>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AppDetail;
